import { Box, Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { getScheduleRecordId } from "library/get-unique-id-from-tree.mjs"
import { ShowActivity } from "routes/@lib/activity/activity.runtime"
import { ActivityOpen, CloseMenu } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function Activity({
    type,
    passedId,
    fileNamePrefix,
    filterFn = () => true,
    filter,
    title = "Activity",
    pageSize,
    ...params
}) {
    const { schedule, closeNow } = useBoundContext()
    const { id: context_id } = schedule || { id: null }
    const id = passedId ?? context_id ?? getScheduleRecordId(params.id)
    const forTypeAllClients = !!params.forTypeAllClients

    ActivityOpen.useEvent(handleShowActivity)

    return (
        <Box>
            <Button
                onClick={handleShowActivity}
                startIcon={<Iconify icon="ic:round-restore" />}
                variant="text"
                id="activityBtn"
                data-cy="activity-button"
            >
                {title}
            </Button>
        </Box>
    )

    function handleShowActivity() {
        closeNow()
        CloseMenu.raise()
        ShowActivity.raise({ id, type, forTypeAllClients, fileNamePrefix, filterFn, filter, pageSize })
    }
}
